import {DeleteProduct} from './../../../utils/functions'

import styles from './DeleteProductButton.module.css';

export const DeleteProductButton = ({ id, address }) => {
    return (
        <button className={styles.button}
                onClick={() => DeleteProduct(id, address)}>Видалити</button>
    )
}